import { createContext } from 'react';
import { createSelectorHook } from 'react-redux';

/** @internal */
export const tokenizedApiStoreContext = createContext<any>(null);
/** @internal */
export const useTokenizedApiStateSelector = createSelectorHook(
  tokenizedApiStoreContext,
);
